export default __webpack_public_path__ + "static/media/use_action_back_hk.552b400f.png";